var BankFeatures = function() {

	var comp = $('[data-component="bank-features"]');

	this.init = function() {

		if($(window).width() > 1024) {

			comp.find('.card').stop().on('mouseenter', function(e) {
				comp.addClass('focus');
				comp.find('.card').addClass('less');
				$(this).removeClass('less').addClass('open');
			}).stop().on('mouseleave', function(e) {
				comp.removeClass('focus');
				$(this).removeClass('open');
				comp.find('.card').removeClass('less');
			});

		}

	}

	return this.init();

}
